import { createSelector } from '@reduxjs/toolkit'
import { jwtDecode } from 'jwt-decode'

import { Jwt } from '@app/models'

import { initialState } from './constants'

const decodedTokenData = createSelector(
  (state = initialState) => state.tokenData,
  ({ token }: { token: string }): Jwt | null =>
    (token && (jwtDecode(token) as Jwt)) || null
)

const decodedOriginalTokenData = createSelector(
  (state = initialState) => state.tokenData,
  ({ originalToken }: { originalToken: string }): Jwt | null =>
    (originalToken && (jwtDecode(originalToken) as Jwt)) || null
)

export const getTokenUserId = createSelector(decodedTokenData, (jwt) =>
  jwt?.user_id && jwt?.auth_state == 'UserAuthenticated'
    ? parseInt(jwt.user_id)
    : null
)

export const getTokenAccountId = createSelector(decodedTokenData, (jwt) =>
  jwt?.account_id ? parseInt(jwt.account_id) : null
)

export const getOriginalTokenUserId = createSelector(
  decodedOriginalTokenData,
  (jwt) => (jwt?.user_id ? parseInt(jwt.user_id) : null)
)
